import React from 'react'

export const GraingerAccountContext = React.createContext();